import CALENDAR_CONSTANTS from '../constants/calendar';
import format from "date-fns/format";


function buildGoogleOAuthUrl({
    state,
    clientId,
    redirectUri,
    scopes = CALENDAR_CONSTANTS.GOOGLE_OAUTH_PERMISSION_SCOPES,
  }){
    const encodedState = encodeURIComponent(JSON.stringify(state));
    const encodedScopes = encodeURIComponent(scopes.join(" "));
    const encodedRedirectUri = encodeURIComponent(redirectUri);
    const encodedClientId = encodeURIComponent(clientId);

    return `https://accounts.google.com/o/oauth2/v2/auth?scope=${encodedScopes}&access_type=offline&prompt=consent&include_granted_scopes=true&response_type=code&state=${encodedState}&redirect_uri=${encodedRedirectUri}&client_id=${encodedClientId}`;
  }


function buildMicrosoftOAuthUrl({
    state,
    clientId,
    redirectUri,
    scopes = CALENDAR_CONSTANTS.MICROSOFT_OAUTH_PERMISSION_SCOPES,
  }){
    const encodedState = encodeURIComponent(JSON.stringify(state));
    const encodedScopes = encodeURIComponent(scopes.join(" "));
    const encodedRedirectUri = encodeURIComponent(redirectUri);
    const encodedClientId = encodeURIComponent(clientId);

    return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?scope=${encodedScopes}&response_type=code&response_mode=query&prompt=consent&state=${encodedState}&redirect_uri=${encodedRedirectUri}&client_id=${encodedClientId}`;
  }



function extractDateFromMeeting(start_time,end_time) {
  const startTime = new Date(start_time);
  const endTime = new Date(end_time);
  const startDate = startTime.getDate();
  const endDate = startTime.getDate();
  const startMonth = startTime.getMonth();
  const endMonth = startTime.getMonth();
  const formattedStartTime = format(startTime, "p");
  const formattedEndTime = format(endTime, "p");
  let dateString;
  if (startDate === endDate && startMonth === endMonth) {
      dateString = `${CALENDAR_CONSTANTS.months[startMonth]} ${startDate} • ${formattedStartTime} -> ${formattedEndTime}`;
  }
  else if (startDate != endDate && startMonth == endMonth) {
      //same month, diff date
  }
  else {
      //diff month
  }
  return dateString;
}

export default {
  buildGoogleOAuthUrl,
  buildMicrosoftOAuthUrl,
  extractDateFromMeeting
};
